import React, { Dispatch, SetStateAction, RefObject, KeyboardEvent, useState, useRef, useEffect, useCallback } from 'react';
import StyledInput from '../atoms/StyledInput';
import StyledButton from '../atoms/StyledButton';
import ModalContainer, { ButtonGroup } from '../../components/modal/ModalContainer';
import theme from '@styles/theme';

type SearchModalProps = {
	setSearchModal: Dispatch<SetStateAction<boolean>>;
	onSearch: (value: string) => void;
}

const SearchModal = ({
	setSearchModal,
	onSearch
}: SearchModalProps) => {
	const [input, setInput] = useState('');
	const inputRef = useRef<HTMLInputElement>(null) as RefObject<HTMLInputElement>;
	
	const handleClose = useCallback(() => {
		setSearchModal(false);
		setInput('');
	}, [setSearchModal]);
	
	const handleEnter = useCallback(() => {
		onSearch(input);
		handleClose();
	}, [input, handleClose, onSearch]);
	
	
	const onKeyPress = useCallback(async (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleEnter();
		}
	}, [handleEnter]);
	
	useEffect(() => {
		inputRef.current?.focus()
	}, [inputRef]);
	
    return (
        <ModalContainer
            title="검색하기"
            onClose={handleClose}>
	        <StyledInput
		        ref={inputRef}
		        value={input}
		        onChange={e => setInput(e.target.value)}
		        onKeyPress={onKeyPress}
		        placeholder="검색어를 입력해주세요."
	        />
	        <ButtonGroup>
		        <StyledButton
			        title="취소"
			        width={140}
			        fontColor={theme.colors.blackColor}
			        border={`1px solid ${theme.colors.lightGrayBorder}`}
			        bgColor={theme.colors.whiteColor}
			        onClick={handleClose}
		        />
                <StyledButton
	                title="이동"
	                width={140}
	                fontColor={theme.colors.whiteColor}
	                border="none"
	                bgColor={theme.colors.blackColor}
	                onClick={handleEnter}
                />
	        </ButtonGroup>
        </ModalContainer>
    );
}

export default SearchModal;
